import { useEffect, useState } from 'react';
import { fetchSiteConfiguration, getCurrentConfig, SiteConfig } from '../config/siteConfig';

/**
 * Hook to use site configuration
 * Ensures configuration is loaded from backend
 */
export const useSiteConfig = () => {
  const [config, setConfig] = useState<SiteConfig>(getCurrentConfig());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchSiteConfiguration()
      .then((newConfig) => {
        setConfig(newConfig);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to load site configuration:', err);
        setError('Failed to load site configuration');
        setConfig(getCurrentConfig()); // Use defaults on error
        setLoading(false);
      });
  }, []);

  return { config, loading, error };
};